"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const leaflet_1 = __importDefault(require("leaflet"));
const osmHelpers_1 = require("../helpers/osmHelpers");
class AddMarkersFromLocations {
    constructor(container, map, markers, postMarkerPairs, createMarker, createTooltip) {
        this.container = container;
        this.map = map;
        this.markers = markers;
        this.postMarkerPairs = postMarkerPairs;
        this.createMarker = createMarker;
        this.createTooltip = createTooltip;
        this.add((0, osmHelpers_1.getMarkerDataFromElement)(this.container));
    }
    add(locations) {
        var _a;
        locations.forEach((location) => {
            var _a, _b;
            if ((location === null || location === void 0 ? void 0 : location.lat) && (location === null || location === void 0 ? void 0 : location.lng)) {
                let customIcon = undefined;
                if (location === null || location === void 0 ? void 0 : location.icon) {
                    customIcon = location.icon;
                }
                let marker = leaflet_1.default.marker([location.lat, location.lng], {
                    icon: this.createMarker.create(customIcon),
                });
                if (location.tooltip) {
                    marker.bindPopup(this.createTooltip.create(location.tooltip, (_a = location.id) !== null && _a !== void 0 ? _a : null), { maxWidth: 200 });
                }
                marker.on('click', (e) => {
                    var _a, _b, _c, _d, _e;
                    let latlng = e.latlng || ((_a = e.sourceTarget) === null || _a === void 0 ? void 0 : _a._latlng) || false;
                    let zoomLevel = (_c = (_b = this.map) === null || _b === void 0 ? void 0 : _b.getZoom()) !== null && _c !== void 0 ? _c : 16;
                    if (latlng) {
                        if (zoomLevel >= 16) {
                            (_d = this.map) === null || _d === void 0 ? void 0 : _d.setView(latlng);
                        }
                        else {
                            (_e = this.map) === null || _e === void 0 ? void 0 : _e.setView(latlng, 16);
                        }
                    }
                });
                (_b = this.markers) === null || _b === void 0 ? void 0 : _b.addLayer(marker);
                this.addMarkerPostPair(marker, location === null || location === void 0 ? void 0 : location.element, location === null || location === void 0 ? void 0 : location.id);
            }
        });
        (_a = this.markers) === null || _a === void 0 ? void 0 : _a.addTo(this.map);
    }
    addMarkerPostPair(marker, post, id) {
        if (marker && post) {
            this.postMarkerPairs.set({ post: post, marker: marker, id: id });
        }
    }
}
exports.default = AddMarkersFromLocations;
